import {
  INIT_POSTS_PAGE_ROUTINE,
  CHANGE_POSTS_PAGINATION,
  FETCH_ARCHIVED_POSTS_ROUTINE,
  FETCH_DRAFT_POSTS_ROUTINE,
} from "constants/ActionTypes";
import { createReducer } from "@reduxjs/toolkit";
import { getInitialPostsPageSize } from "constants/PostsPagination";

const initialState = {
  pages: [],
  numPages: null,
  currentPage: null,
  lastPage: null,
  pageSize: null,
};

const applyFetchedPagination = (state, action) => ({
  ...state,
  ...action.payload.pagination,
});

export const paginationReducer = createReducer(initialState, (builder) => {
  builder.addCase("SET_PAGINATION", (state, action) => {
    let { numPages, currentPage, pageSize } = action.payload;
    return {
      ...state,
      numPages,
      currentPage,
      pageSize,
    };
  });
  builder.addCase("CHANGE_PAGE_SIZE", (state, action) => {
    const { pageSize } = action.payload;
    return {
      ...state,
      currentPage: 1,
      pageSize,
    };
  });
  builder.addCase("CHANGE_PAGE", (state, action) => {
    const { page } = action.payload;
    return {
      ...state,
      currentPage: page,
    };
  });
  builder.addCase("INIT_POSTS_VIEW", (state) => {
    return {
      ...state,
      currentPage: 1,
    };
  });
  builder.addCase("CHANGE_POST_PAGE", (state, action) => {
    return {
      ...state,
      currentPage: action.payload,
    };
  });
  builder.addCase("CHANGE_POST_PAGE_SIZE", (state, action) => {
    return {
      ...state,
      pageSize: action.payload,
    };
  });
  builder.addCase(CHANGE_POSTS_PAGINATION.TRIGGER, (state, action) => {
    const { page, pageSize } = action.payload;
    return {
      ...state,
      currentPage: page,
      pageSize,
    };
  });
  builder.addCase(INIT_POSTS_PAGE_ROUTINE.TRIGGER, (state, action) => {
    state.currentPage = 1;
    state.pageSize =
      action.payload.pageSize ?? getInitialPostsPageSize(action.payload.page);
    return state;
  });
  builder.addCase(FETCH_DRAFT_POSTS_ROUTINE.SUCCESS, applyFetchedPagination);
  builder.addCase(FETCH_ARCHIVED_POSTS_ROUTINE.SUCCESS, applyFetchedPagination);
});

function range(start, end) {
  var values = [];
  for (; start <= end; start++) {
    values.push(start);
  }
  return values;
}

export function makePages(data, total, currentPage, lastPage) {
  let pages = [];

  if (lastPage <= 10) {
    return range(1, lastPage);
  }

  if (currentPage <= 4) {
    return range(1, 5).concat([{ placeholder: true }, lastPage]);
  }

  pages = [1, { placeholder: true }];
  if (lastPage - currentPage <= 4) {
    return pages.concat(range(lastPage - 5, lastPage));
  }

  return pages
    .concat(range(currentPage - 2, currentPage + 2))
    .concat({ placeholder: true }, lastPage);
}
